import { useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { api } from "@/lib/api";

// One assistant's own Queue switch (the all-assistants switch resets these).
export default function MemberQueueSwitch({ m, onChanged }) {
  const [on, setOn] = useState(!!m.hide_queue);
  const change = async (v) => {
    setOn(v);
    try {
      await api.put(`/team/${m.id}/queue-setting`, { hide_queue: v });
      toast.success(v ? `Queue hidden for ${m.email}` : `${m.email} has the Queue again`);
      onChanged();
    } catch {
      setOn(!v);
      toast.error("Couldn't save that");
    }
  };
  return (
    <label className="flex items-center justify-between gap-2 text-[11px] text-slate-600" data-testid={`team-member-hide-queue-${m.id}`}>
      <span>{on ? "Queue hidden: batches only" : "Queue on"}</span>
      <Switch checked={on} onCheckedChange={change} className="scale-90" data-testid={`team-member-hide-queue-switch-${m.id}`} />
    </label>
  );
}
